import React from "react";
import { useLang } from "@/context/LanguageContext";
import { CHECK_LABELS } from "./InspectionConstants";

// Renders a single 5-domain checklist domain — pass/fail/na buttons per item
// plus an optional note field when the item is marked "fail". Fully controlled;
// the parent form owns the `checks` state and mutates via callbacks.
export function ChecklistDomain({ domain, checks, onSetCheck, onSetNote }) {
  const { t, lang } = useLang();
  return (
    <section className="hag-surface p-4 mt-4" data-testid={`checklist-${domain.key}`}>
      <h3 className="text-sm font-bold uppercase tracking-widest text-[#4A627A] mb-3">{t(domain.labelKey)}</h3>
      <div className="space-y-2">
        {domain.items.map((item) => (
          <div key={item} className="py-2 border-b border-[#1B3A5C]/5 last:border-0">
            <div className="text-sm font-medium">{CHECK_LABELS[item]?.[lang] || item}</div>
            <div className="flex gap-2 mt-1">
              {["pass", "fail", "na"].map((v) => (
                <button
                  key={v}
                  data-testid={`check-${item}-${v}`}
                  onClick={() => onSetCheck(item, v)}
                  className={`tap-target flex-1 h-10 rounded-md text-xs font-bold border ${
                    checks[item]?.status === v
                      ? (v === "pass" ? "grade-A" : v === "fail" ? "grade-C" : "bg-[#F1F5F9]")
                      : "bg-white border-[#1B3A5C]/15"
                  }`}
                >
                  {t(v)}
                </button>
              ))}
            </div>
            {checks[item]?.status === "fail" && (
              <input
                placeholder={t("note")}
                value={checks[item]?.note || ""}
                onChange={(e) => onSetNote(item, e.target.value)}
                className="mt-2 w-full h-10 px-2 border border-[#1B3A5C]/15 rounded-md text-sm"
              />
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
